import { useEffect } from 'react';
import '../../styles/Busquedas/hiring.scss';

export const Hiring = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Verificar si el iframe ya existe
    let iframe = document.getElementById('hiringroom-iframe-id') as HTMLIFrameElement;
    if (!iframe) {
      // Crear el iframe dinámicamente
      iframe = document.createElement('iframe') as HTMLIFrameElement;
      iframe.id = 'hiringroom-iframe-id';
      iframe.src = 'https://hiringroom.com/api/vacancies/get_vacancy_list_frame/serendipia';
      iframe.width = '100%';
      iframe.frameBorder = '0';
      iframe.style.maxHeight = '4000px';
      iframe.style.overflowY = 'scroll';
    
      // Insertar el iframe en el div
      const iframeContainer = document.getElementById('iframe-container');
      if (iframeContainer) {
        iframeContainer.appendChild(iframe);
      }
    }

    // Agregar el listener para ajustar la altura del iframe
    const handleMessage = (e: any) => {
      if (e.data.height) {
        iframe.height = e.data.height + 'px';
      }
    };


    window.addEventListener('message', handleMessage);

    // Limpiar el event listener cuando el componente se desmonte
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return <div className='hiring'>
    <div id="iframe-container"></div>;
  </div> 
};
